import { type EmptyObject } from '@ve/types/EmptyObject';

interface BonusMilesParams {
    bonusMiles?: true;
}

export default (params: Record<string, string>): BonusMilesParams | EmptyObject => {
  const { bonusMiles } = params;

  if (!bonusMiles) {
    return {};
  }

  return { bonusMiles: true };
};
